module.exports = __webpack_public_path__ + "static/crater-founders-2bdc4740f1528d0b71a3c588b1b45248.jpg";